import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiCoffee, FiUser, FiArrowRight } from 'react-icons/fi';

function Landing() {
  const navigate = useNavigate();

  const loginOptions = [
    {
      id: 'restaurant',
      title: 'Restaurant Admin',
      description: 'Manage menu, orders, tables, and bills',
      icon: FiCoffee,
      path: '/login/restaurant'
    },
    {
      id: 'staff',
      title: 'Restaurant Staff',
      description: 'View orders and manage kitchen operations',
      icon: FiUser,
      path: '/login/staff'
    }
  ];

  return (
    <div className="min-h-screen w-full bg-gray-50 flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 bg-gray-50 flex flex-col justify-center p-8 sm:p-12 lg:p-16 relative">
        <div className="absolute top-6 left-6 sm:top-8 sm:left-8">
          <img src="/logo-1.png" alt="Elyspr Logo" className="h-28 w-auto" />
        </div>

        <div className="max-w-lg mx-auto mt-10 lg:mt-0 text-center">
          <h1 className="text-5xl font-bold text-gray-900 tracking-tight">ElyDine</h1>
          <p className="mt-4 text-xl text-gray-700 font-medium">Restaurant Management System</p>
          <p className="mt-10 text-xl text-gray-800 italic leading-relaxed">
            “Great service is built on simple workflows and confident teams.”
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 bg-black flex flex-col justify-center p-8 sm:p-12 lg:p-16">
        <div className="w-full max-w-xl mx-auto">
          <div className="mb-8 text-center">
            <h2 className="text-3xl font-bold text-white tracking-tight">Choose Your Portal</h2>
            <p className="text-sm text-gray-300 mt-2">Sign in to continue to your workspace</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {loginOptions.map((option) => {
              const Icon = option.icon;
              return (
                <button
                  key={option.id}
                  onClick={() => navigate(option.path)}
                  className="w-full h-full min-h-[220px] bg-gray-800 border border-gray-600 rounded-2xl p-6 text-left hover:bg-gray-700 hover:border-gray-400 transition-all duration-200"
                >
                  <div className="h-full flex flex-col justify-between gap-6">
                    <div className="space-y-4">
                      <div className="h-12 w-12 rounded-lg bg-gray-100 text-gray-900 flex items-center justify-center">
                        <Icon className="text-xl" />
                      </div>
                      <div>
                        <h3 className="text-xl font-semibold text-white leading-tight">{option.title}</h3>
                        <p className="text-sm text-gray-300 mt-2">{option.description}</p>
                      </div>
                    </div>
                    <div className="h-10 w-10 rounded-full bg-gray-100 text-gray-900 flex items-center justify-center self-end">
                      <FiArrowRight />
                    </div>
                  </div>
                </button>
              );
            })}
          </div>

          <div className="mt-8 text-xs text-gray-400 text-center">© 2026 Elyspr. All rights reserved.</div>
        </div>
      </div>
    </div>
  );
}

export default Landing;
